// See: https://vuex.vuejs.org/guide/modules.html
import {EMPTY_SEARCH_WRAPPER} from "../../../util/consts";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const data = {
  namespaced: true,
  state: {
    config: {
      availableWorkflows: [],
      selectedWorkflows: [],
      availableResultWorkflows: [],
      selectedResultWorkflows: [],
      availableLanguages: [],
      availablePeopleGroups: [],
      availableCaseRoles: [],
      availableElementStates: [],
      availableCaseStates: [],
      availableUploadTypes: [],
      labels: [],
      autoApprovalRoles: [],
      timeZone: "America/Vancouver",
      displayNotes: false,
      displayIncidents: false,
      displayIncidentColors: false,
      highlightSignalsInText: false,
      includeSearchWordSignals: false,
      includeCaseKeywordSignals: false,
      includeCodeWordSignals: false,
      translationIsActive: false,
    },
    showUploadsPopover: false,
    highlightPaths: [],
    uploads: {},
    cases: {},
    caseSummaries: Object.assign({}, EMPTY_SEARCH_WRAPPER),
    caseUploadSummaries: Object.assign({}, EMPTY_SEARCH_WRAPPER),
    caseUploadClipSummaries: Object.assign({}, EMPTY_SEARCH_WRAPPER),
    caseUploadEvidenceSummaries: Object.assign({}, EMPTY_SEARCH_WRAPPER),
    caseClipSummaries: {},
    caseEvidenceSummaries: {},
    caseActorAttributions: {},
    caseUserAttributions: {},
    actors: {},
    actorMap: {},
    userMap: {},
    codeWordGroups: {},
    people: {},
    loadedPeople: false,
    loadedPeopleGroups: [],
    transcriptions: {},
    searchKeyword: "",
    searches: [],
    uploadResponses: [],
    workflowResponses: [],
    searchRadioOpts: [
      {name: "Transcriptions", label: "Transcription Results", key: "transcriptions"},
      {name: "Cases", label: "Cases", key: "cases"},
      {name: "Uploads", label: "Upload Name", key: "uploads"},
    ],
    caseClip: {},
    breadcrumbHints: {},
    highlightSnippet: null,
    highlightSnippetSide: null,
    caseSummaryUpdateCount: 0,
  },
  actions,
  getters,
  mutations,
};

export default data;
